import React, { lazy, useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "./contexts/ThemeContext";
import QueryProvider from "./api-services/config/QueryProvider";
import { SessionProvider } from "./contexts/SessionExpiryContext";
import AppRoutes from "./Routes";
import { useStore } from "./store/store";

function App() {
  const restoreAuth = useStore((s) => s?.auth?.restoreAuth);
  const initialized = useStore((s) => s?.auth?.initialized);

  useEffect(() => {
    if (!initialized) {
      restoreAuth();
    }
  }, [initialized, restoreAuth]);

  return (
    <QueryProvider>
      <TooltipProvider>
        <ThemeProvider>
          <SessionProvider>
            <Toaster />
            <Sonner />
            <AppRoutes />
          </SessionProvider>
        </ThemeProvider>
      </TooltipProvider>
    </QueryProvider>
  );
}

export default App;
